import { render, staticRenderFns } from "./CreateDataLog.vue?vue&type=template&id=5af69ee0&scoped=true"
import script from "./CreateDataLog.vue?vue&type=script&lang=js"
export * from "./CreateDataLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af69ee0",
  null
  
)

export default component.exports